import React from 'react';
import '../common.scss';
import './styles.scss';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps {
  id?: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
  value?: string;
  options: string[] | SelectOption[];
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  className?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const SelectComponent: React.FC<SelectProps> = ({
  id,
  name,
  required = false,
  disabled = false,
  value = '',
  options = [],
  placeholder = 'Choose one...',
  onChange,
  onBlur,
  onFocus,
  className = '',
  ...ariaProps
}) => {
  const normalizedOptions = options.map(option =>
    typeof option === 'string' ? { value: option, label: option } : option
  );

  return (
    <select
      id={id}
      name={name}
      required={required}
      disabled={disabled}
      value={value}
      autoComplete="off"
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      className={clsx('peptalk-form-element peptalk-select', className)}
      {...ariaProps}
    >
      <option value="">{placeholder}</option>
      {normalizedOptions.map((option, index) => (
        <option
          key={`${option.value}-${index}`}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
};

export const Select: React.FC<SelectProps> = (props: SelectProps) => {
  const Component = useCustomComponent({
    componentName: 'Select',
    Component: SelectComponent,
  });

  return <Component {...props} />;
};
